module.exports = __webpack_public_path__ + "static/media/2.286f2e65.jpg";